const camelcaseKeysDeep = require('camelcase-keys-deep');

export class MedicalService {
  id: string;
  name: string;
  key: string;
  description: string;
  cptCode: string;
  workpathId: string;
  createdDate: Date;
  updatedDate: Date;
  cost: number;

  constructor(recordInfo: any) {
    recordInfo = camelcaseKeysDeep(recordInfo);

    this.id = recordInfo.id;
    this.name = recordInfo.name;
    this.key = recordInfo.key;
    this.description = recordInfo.description;
    this.cptCode = recordInfo.cptCode;
    this.workpathId = recordInfo.workpathId;
    this.createdDate = recordInfo.createdDate;
    this.updatedDate = recordInfo.updatedDate;
    this.cost = recordInfo.cost;
  }
}



// WEBPACK FOOTER //
// ./src/app/medical-services/medical-service.ts